<template>
  <div>
    <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="40" full-width lazy
            min-width="290px"
            offset-y transition="scale-transition">
      <template v-slot:activator="{ on }">
        <v-text-field v-model="model" :label="label" prepend-icon="event" readonly clearable v-on="on"></v-text-field>
      </template>

      <v-date-picker
        v-model="model"
        :locale="locale"
        :min="getMinDate()"
        :max="getMaxDate()"
        :allowed-dates="isAllowed"
         @input="menuDate = false"
        :landscape="false">
      </v-date-picker>

    </v-menu>
    {{ description }}
  </div>
</template>

<script>
import {input} from '@/mixins/input'
import moment from "moment"

export default {
  mixins: [input],
  data() {
    return {
      menuDate: false
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  mounted() {
    if (this.$route.query.date) {
      this.model = this.$route.query.date
      this.value = this.$route.query.date
    }
  },
  methods:{
    getMinDate(){
      if(this.field && this.field.options && this.field.options.daysRange){
        return (new moment()).format('YYYY-MM-DD')
      }

      return (new moment()).add(-100,'y').format('YYYY-MM-DD')
    },
    getMaxDate(){
      if(this.field && this.field.options && this.field.options.daysRange){
        return (new moment()).add(this.field.options.daysRange,'d').format('YYYY-MM-DD')
      }

      return (new moment()).add(100,'y').format('YYYY-MM-DD')
    },
    isAllowed(date){
      if(this.field.options && this.field.options.showOnlySelectedDays &&
          this.field.options.daysOfWeek && Array.isArray(this.field.options.daysOfWeek)){
        return this.field.options.daysOfWeek.includes((new moment(date, 'YYYY-MM-DD')).weekday())
      }

      return true
    },
  },
}
</script>

<style>
</style>
